<div class="container my-4">
  <div class="row">
    <div class="col-12 ">
      <span class="title_header_bar">Manage Device</span>
    </div>
  </div>
  <div class="card card_content">
    <form [formGroup]="form">

      <div class="row mb-3 d-felx justify-content-center align-items-center flex-wrap grid-margin">
        <div class="col-md-3">
          <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
            <i class="fa fa-refresh"></i> Refresh
          </button> -->
          <app-button (refreshClicked)="clearFilter()"></app-button>

          <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
            <i class="fa fa-file-excel"></i> Export
          </button>

        </div>
        <div class="col-md-4 padd-right-file" style="display: flex;">
          <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
            <mat-label>Search</mat-label>
            <div class="search-input-container">
              <input placeholder="Enter Model / Version / Serial / Mac" id="search" matInput formControlName="search"
                type="text" #searchInput>
            </div>
          </mat-form-field>
          <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
            (click)="searchinput()">
            <mat-icon style="color: white;">search</mat-icon>
          </button>

        </div>
        <div class="col-4 d-flex justify-content-start">
          <button type="button" class="btn btn-primary text-nowrap mr-2" (click)="gotoadddevice()">
            <i class="fa fa-plus "></i> Add Device
          </button>
          <button type="button" class="btn btn-primary text-nowrap " (click)="importexcel()">
            <i class="fa fa-plus "></i>  import Devices
          </button>
          <!-- <button type="button" class="btn btn-primary ml-2 d-flex" (click)="filterOpen = !filterOpen">
            <ng-container *ngIf="!filterOpen">
              <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
            </ng-container>
            <ng-container *ngIf="filterOpen">
              <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
            </ng-container>
            <span class="ml-2">Filters</span>
          </button> -->
        </div>


      </div>

      <div [@detailExpand]="filterOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">
        <hr>
        <div class="row my-3 d-flex justify-content-between align-items-center flex-wrap grid-margin">
          
          <div class="col-3"></div>
          <div class="col-xl-4 ">
            <mat-form-field appearance="fill" hideRequiredMarker>
              <mat-label>Role</mat-label>
              <mat-select class="scrollbarcs" formControlName="filter" (selectionChange)="getFilter($event.value)"
                placeholder="Select Primary Product ">
                <mat-select-filter [displayMember]="'value'"></mat-select-filter>
                <mat-option *ngFor="let role of filter" [value]="role.key" style="overflow-y: scroll !important;">
                  {{role.value}}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
          <div class="col">
            <button type="button" class="btn reset_btn  " (click)="reset()">
              <i class="fa fa-refresh"></i> Reset
            </button>
          </div>
          <div class="col-5"></div>

        </div>
      </div>
      <div class="table-responsive mt-2 mb-4">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

          <ng-container matColumnDef="model">
            <mat-header-cell *matHeaderCellDef>Model</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign"> {{dataField.model}}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="version">
            <mat-header-cell *matHeaderCellDef>Version</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.software_version}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="serial">
            <mat-header-cell *matHeaderCellDef> Serial</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.serial}} </p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="mac">
            <mat-header-cell *matHeaderCellDef>Mac</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.mac}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>
              <span class="mr-2">Status</span>
              <i class="fa fa-filter" [matMenuTriggerFor]="filterMenu"></i></mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign mx-2"
                [ngClass]="{'green-bg': dataField.deviceStatus === 1, 'red-bg': dataField.deviceStatus !== 1}">
                {{dataField.deviceStatusName}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="assignedto">
            <mat-header-cell *matHeaderCellDef>Assigned to</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.customerName}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="assignedfrom">
            <mat-header-cell *matHeaderCellDef>Assigned form</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.assignedfrom}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="InvoiceNumber">
            <mat-header-cell *matHeaderCellDef>Invoice Number</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.var1}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Supplier">
            <mat-header-cell *matHeaderCellDef>Supplier</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.var2}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="PurchasedDesign">
            <mat-header-cell *matHeaderCellDef>Date Purchased</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.var3 | date:'dd-MM-yyyy HH:mm:ss'}}</p>
            </mat-cell>
          </ng-container>




          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
          </mat-row>
        </mat-table>
        <mat-menu #filterMenu="matMenu">
          <ng-container *ngFor="let value of uniqueStatuses">
              <button mat-menu-item (click)="applyFilter(value)">{{ value }}</button>
          </ng-container>
          <button mat-menu-item (click)="applyFilter('clear')">Clear</button>
      </mat-menu>
      </div>

      <div class="table_pagenation">
        <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
          [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
        </mat-paginator>
      </div>
    </form>

  </div>




</div>